import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={39}
    fill="none"
    {...props}
  >
    <g opacity={0.7}>
      <path fill="#000" d="m1.499 13.491.008.003-.008-.003Z" />
      <path
        fill="#00E9BA"
        d="M45.822 14.419v13.134a2.06 2.06 0 0 1-2.056 2.058 2.062 2.062 0 0 1-2.057-2.058v-10.9l4.112-2.234Z"
      />
      <path
        fill="#FF6E58"
        d="M39.331 17.945V28.38c0 1.14-.622 2.19-1.622 2.74L25.47 37.828a3.099 3.099 0 0 1-3.005 0l-12.239-6.71c-1-.549-1.622-1.599-1.622-2.74v-10.41l4.112 2.248v6.326c0 .758.412 1.456 1.076 1.824l9.167 5.06c.63.35 1.386.35 2.016 0l9.168-5.06a2.083 2.083 0 0 0 1.076-1.823v-6.327l3.841-2.099.263-.167.008-.005Z"
      />
      <path
        fill="#3F538D"
        d="M23.967.612 1.248 13.033l-.83.464 8.185 4.45v.022l4.113 2.247 11.251 6.152 11.252-6.152 3.841-2.099.263-.167.008-.005 2.378-1.292 4.112-2.234.865-.472.834-.455L23.966.611Zm0 21.089L9.036 13.494l14.931-8.06 14.932 8.06-14.932 8.207Z"
      />
    </g>
  </svg>
)
export default SvgComponent
